import React, { useEffect, useState } from 'react';

import { Button } from '../../../scripts/components/moderation-v2/sharable/components/Button/Button';

import styles from './EmptyModerationMode.module.scss';

import { useTypedSelector } from 'state';

const images = [
  'heart_emoji',
  'party_popper_emoji',
  'bullseye_emoji',
  'star_emoji',
  'sunglasses_emoji',
  'winking_emoji'
];

const titles = [
  'Awesome work! You’ve cleared the queue like a pro',
  'Great job! All messages handled',
  'Fantastic effort! No more messages left for now',
  'Amazing job! The pending queue is empty thanks to you',
  'Well done! You’ve conquered the queue'
];

const titlesMorePending = [
  'Batch completed!',
  'Great job! You’ve finished this batch.',
  'Well done on this batch!',
  'Nice work! You’ve cleared this batch.',
  'This batch is all set!'
];

const subTitles = [
  'Thanks to you, the community is in great shape. Keep up the good work!',
  'Your diligence helps foster a thriving community.',
  'You’ve left nothing behind — everything’s sorted!',
  'Your dedication ensures a welcoming space for all.',
  'Every message is in good hands, thanks to your hard work.'
];

const subTitlesMorePending = [
  'There are still more comments in the queue. Ready to start a new session?',
  'There is more waiting in the queue. Ready to start a new session?',
  'There are still pending comments if you’re up for another round.',
  'There are more comments in the queue to tackle when you’re ready.',
  'More comments are waiting in the queue if you’d like to continue.'
];

interface Data {
  image: string;
  title: string;
  subTitle: string;
}

export interface EmptyModerationModeProps {
  onClick: () => void;
}

export function EmptyModerationMode(props: EmptyModerationModeProps) {
  const { onClick } = props;

  const hasMorePending = useTypedSelector(state => state.moderation.messages.hasMorePending);
  const hasMorePendingStatus = useTypedSelector(state => state.moderation.messages.hasMorePendingStatus);

  const [data, setData] = useState<Data>();

  useEffect(() => {
    setData({
      image: getRandomItem(images),
      title: getRandomItem(hasMorePending ? titlesMorePending : titles),
      subTitle: getRandomItem(hasMorePending ? subTitlesMorePending : subTitles)
    });
  }, [hasMorePending]);

  if (!data || hasMorePendingStatus === 'loading') {
    return null;
  }

  return (
    <div className={styles.container}>
      <img width={46} height={46} src={`https://admin.spot.im/assets/images/${data?.image}.png`} alt="Happy heart" />
      <span className={styles.title}>{data?.title}</span>
      <span className={styles.subTitle}>{data?.subTitle}</span>
      {hasMorePending && (
        <Button theme="contained-apply" onClick={onClick}>
          Start new session
        </Button>
      )}
    </div>
  );
}

function getRandomItem(items: string[]) {
  return items[Math.floor(Math.random() * items.length)];
}
